var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-datepicker",
    {
      ref: "datepicker",
      attrs: {
        "md-disabled-dates": _vm.disabledDates,
        "md-immediately": _vm.closeOnSelect,
        value: _vm.value,
      },
      on: {
        input: function ($event) {
          return _vm.$emit("input", $event)
        },
        "md-opened": function ($event) {
          return _vm.$emit("open")
        },
        "md-closed": function ($event) {
          return _vm.$emit("close")
        },
        "md-clear": _vm.clear,
      },
    },
    [_c("label", [_vm._v(_vm._s(_vm.label))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }